import { StaticImageData } from "next/image";

//Tables
import CoffeeTable_circularElliptic from '@/assets/images/scan/Tables/CoffeeTable_circularElliptic.png';
import CircularElliptic_coffeeTable from '@/assets/images/scan/Tables/CoffeeTable_circularElliptic.png';
import CoffeeTable_rectangular from '@/assets/images/scan/Tables/CoffeeTable_rectangular.png';
import Rectangular_coffeeTable from '@/assets/images/scan/Tables/CoffeeTable_rectangular.png';
import CoffeeTable_unidentifiedShape from '@/assets/images/scan/Tables/CoffeeTable_unidentifiedShape.png';
import UnidentifiedShape_coffeeTable from '@/assets/images/scan/Tables/CoffeeTable_unidentifiedShape.png';
import DefaultTable from '@/assets/images/scan/Tables/DefaultTable.png';
import DiningTable_circularElliptic from '@/assets/images/scan/Tables/DiningTable_circularElliptic.png';
import CircularElliptic_diningTable from '@/assets/images/scan/Tables/DiningTable_circularElliptic.png';
import DiningTable_rectangular from '@/assets/images/scan/Tables/DiningTable_rectangular.png';
import Rectangular_diningTable from '@/assets/images/scan/Tables/DiningTable_rectangular.png';
import DiningTable_unidentifiedShape from '@/assets/images/scan/Tables/DiningTable_unidentifiedShape.png';
import UnidentifiedShape_diningTable from '@/assets/images/scan/Tables/DiningTable_unidentifiedShape.png';
import Unidentified_circularElliptic from '@/assets/images/scan/Tables/Unidentified_circularElliptic.png';
import CircularElliptic_unidentified from '@/assets/images/scan/Tables/Unidentified_circularElliptic.png';
import Unidentified_lShaped from '@/assets/images/scan/Tables/Unidentified_lShaped.png';
import LShaped_unidentified from '@/assets/images/scan/Tables/Unidentified_lShaped.png';
import Unidentified_rectangular from '@/assets/images/scan/Tables/Unidentified_rectangular.png';
import Rectangular_unidentified from '@/assets/images/scan/Tables/Unidentified_rectangular.png';
import Unidentified_unidentifiedShape from '@/assets/images/scan/Tables/Unidentified_unidentifiedShape.png';
import UnidentifiedShape_unidentified from '@/assets/images/scan/Tables/Unidentified_unidentifiedShape.png';
//Chairs
import DefaultChair from '@/assets/images/scan/Chairs/DefaultChair.png';
import DiningChair_wBack_fourLegs_noArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import DiningChair_wBack_noArms_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import DiningChair_fourLegs_wBack_noArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import DiningChair_fourLegs_noArms_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import DiningChair_noArms_wBack_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import DiningChair_noArms_fourLegs_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import WBack_diningChair_fourLegs_noArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import WBack_diningChair_noArms_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import WBack_fourLegs_diningChair_noArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import WBack_fourLegs_noArms_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import WBack_noArms_diningChair_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import WBack_noArms_fourLegs_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import FourLegs_diningChair_wBack_noArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import FourLegs_diningChair_noArms_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import FourLegs_wBack_diningChair_noArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import FourLegs_wBack_noArms_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import FourLegs_noArms_diningChair_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import FourLegs_noArms_wBack_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import NoArms_diningChair_wBack_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import NoArms_diningChair_fourLegs_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import NoArms_wBack_diningChair_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import NoArms_wBack_fourLegs_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import NoArms_fourLegs_diningChair_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import NoArms_fourLegs_wBack_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_noArms.png';
import DiningChair_wBack_fourLegs_wArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import DiningChair_wBack_wArms_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import DiningChair_fourLegs_wBack_wArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import DiningChair_fourLegs_wArms_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import DiningChair_wArms_wBack_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import DiningChair_wArms_fourLegs_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WBack_diningChair_fourLegs_wArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WBack_diningChair_wArms_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WBack_fourLegs_diningChair_wArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WBack_fourLegs_wArms_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WBack_wArms_diningChair_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WBack_wArms_fourLegs_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import FourLegs_diningChair_wBack_wArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import FourLegs_diningChair_wArms_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import FourLegs_wBack_diningChair_wArms from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import FourLegs_wBack_wArms_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import FourLegs_wArms_diningChair_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import FourLegs_wArms_wBack_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WArms_diningChair_wBack_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WArms_diningChair_fourLegs_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WArms_wBack_diningChair_fourLegs from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WArms_wBack_fourLegs_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WArms_fourLegs_diningChair_wBack from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';
import WArms_fourLegs_wBack_diningChair from '@/assets/images/scan/Chairs/DiningChair_wBack_fourLegs_wArms.png';

import Stool_noBack_fourLegs_noArms from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import Stool_noBack_noArms_fourLegs from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import Stool_fourLegs_noBack_noArms from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import Stool_fourLegs_noArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import Stool_noArms_noBack_fourLegs from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import Stool_noArms_fourLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoBack_stool_fourLegs_noArms from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoBack_stool_noArms_fourLegs from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoBack_fourLegs_stool_noArms from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoBack_fourLegs_noArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoBack_noArms_stool_fourLegs from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoBack_noArms_fourLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import FourLegs_stool_noBack_noArms from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import FourLegs_stool_noArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import FourLegs_noBack_stool_noArms from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import FourLegs_noBack_noArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import FourLegs_noArms_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import FourLegs_noArms_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoArms_stool_noBack_fourLegs from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoArms_stool_fourLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoArms_noBack_stool_fourLegs from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoArms_noBack_fourLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoArms_fourLegs_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';
import NoArms_fourLegs_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_fourLegs_noArms.png';

import Stool_noBack_starLegs_noArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import Stool_noBack_noArms_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import Stool_starLegs_noBack_noArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import Stool_starLegs_noArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import Stool_noArms_noBack_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import Stool_noArms_starLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoBack_stool_starLegs_noArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoBack_stool_noArms_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoBack_starLegs_stool_noArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoBack_starLegs_noArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoBack_noArms_stool_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoBack_noArms_starLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import StarLegs_stool_noBack_noArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import StarLegs_stool_noArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import StarLegs_noBack_stool_noArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import StarLegs_noBack_noArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import StarLegs_noArms_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import StarLegs_noArms_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoArms_stool_noBack_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoArms_stool_starLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoArms_noBack_stool_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoArms_noBack_starLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoArms_starLegs_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';
import NoArms_starLegs_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_noArms.png';

import Stool_noBack_starLegs_wArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import Stool_noBack_wArms_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import Stool_starLegs_noBack_wArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import Stool_starLegs_wArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import Stool_wArms_noBack_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import Stool_wArms_starLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import NoBack_stool_starLegs_wArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import NoBack_stool_wArms_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import NoBack_starLegs_stool_wArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import NoBack_starLegs_wArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import NoBack_wArms_stool_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import NoBack_wArms_starLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import StarLegs_stool_noBack_wArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import StarLegs_stool_wArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import StarLegs_noBack_stool_wArms from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import StarLegs_noBack_wArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import StarLegs_wArms_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import StarLegs_wArms_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import WArms_stool_noBack_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import WArms_stool_starLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import WArms_noBack_stool_starLegs from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import WArms_noBack_starLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import WArms_starLegs_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';
import WArms_starLegs_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_starLegs_wArms.png';

import Stool_noBack_unidentifiedLegs_noArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import Stool_noBack_noArms_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import Stool_unidentifiedLegs_noBack_noArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import Stool_unidentifiedLegs_noArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import Stool_noArms_noBack_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import Stool_noArms_unidentifiedLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoBack_stool_unidentifiedLegs_noArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoBack_stool_noArms_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoBack_unidentifiedLegs_stool_noArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoBack_unidentifiedLegs_noArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoBack_noArms_stool_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoBack_noArms_unidentifiedLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_stool_noBack_noArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_stool_noArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noBack_stool_noArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noBack_noArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noArms_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noArms_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoArms_stool_noBack_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoArms_stool_unidentifiedLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoArms_noBack_stool_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoArms_noBack_unidentifiedLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoArms_unidentifiedLegs_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';
import NoArms_unidentifiedLegs_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_noArms.png';

import Stool_noBack_unidentifiedLegs_wArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import Stool_noBack_wArms_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import Stool_unidentifiedLegs_noBack_wArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import Stool_unidentifiedLegs_wArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import Stool_wArms_noBack_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import Stool_wArms_unidentifiedLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import NoBack_stool_unidentifiedLegs_wArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import NoBack_stool_wArms_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import NoBack_unidentifiedLegs_stool_wArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import NoBack_unidentifiedLegs_wArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import NoBack_wArms_stool_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import NoBack_wArms_unidentifiedLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import UnidentifiedLegs_stool_noBack_wArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import UnidentifiedLegs_stool_wArms_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import UnidentifiedLegs_noBack_stool_wArms from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import UnidentifiedLegs_noBack_wArms_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import UnidentifiedLegs_wArms_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import UnidentifiedLegs_wArms_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import WArms_stool_noBack_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import WArms_stool_unidentifiedLegs_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import WArms_noBack_stool_unidentifiedLegs from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import WArms_noBack_unidentifiedLegs_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import WArms_unidentifiedLegs_stool_noBack from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';
import WArms_unidentifiedLegs_noBack_stool from '@/assets/images/scan/Chairs/Stool_noBack_unidentifiedLegs_wArms.png';

import Swivel_wBack_starLegs_noArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import Swivel_wBack_noArms_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import Swivel_starLegs_wBack_noArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import Swivel_starLegs_noArms_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import Swivel_noArms_wBack_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import Swivel_noArms_starLegs_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import WBack_swivel_starLegs_noArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import WBack_swivel_noArms_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import WBack_starLegs_swivel_noArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import WBack_starLegs_noArms_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import WBack_noArms_swivel_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import WBack_noArms_starLegs_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import StarLegs_swivel_wBack_noArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import StarLegs_swivel_noArms_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import StarLegs_wBack_swivel_noArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import StarLegs_wBack_noArms_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import StarLegs_noArms_swivel_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import StarLegs_noArms_wBack_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import NoArms_swivel_wBack_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import NoArms_swivel_starLegs_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import NoArms_wBack_swivel_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import NoArms_wBack_starLegs_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import NoArms_starLegs_swivel_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';
import NoArms_starLegs_wBack_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_noArms.png';

import Swivel_wBack_starLegs_wArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import Swivel_wBack_wArms_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import Swivel_starLegs_wBack_wArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import Swivel_starLegs_wArms_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import Swivel_wArms_wBack_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import Swivel_wArms_starLegs_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WBack_swivel_starLegs_wArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WBack_swivel_wArms_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WBack_starLegs_swivel_wArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WBack_starLegs_wArms_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WBack_wArms_swivel_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WBack_wArms_starLegs_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import StarLegs_swivel_wBack_wArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import StarLegs_swivel_wArms_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import StarLegs_wBack_swivel_wArms from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import StarLegs_wBack_wArms_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import StarLegs_wArms_swivel_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import StarLegs_wArms_wBack_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WArms_swivel_wBack_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WArms_swivel_starLegs_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WArms_wBack_swivel_starLegs from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WArms_wBack_starLegs_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WArms_starLegs_swivel_wBack from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';
import WArms_starLegs_wBack_swivel from '@/assets/images/scan/Chairs/Swivel_wBack_starLegs_wArms.png';

import Unidentified_noBack_starLegs_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import Unidentified_noBack_noArms_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import Unidentified_starLegs_noBack_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import Unidentified_starLegs_noArms_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import Unidentified_noArms_noBack_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import Unidentified_noArms_starLegs_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoBack_unidentified_starLegs_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoBack_unidentified_noArms_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoBack_starLegs_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoBack_starLegs_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoBack_noArms_unidentified_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoBack_noArms_starLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import StarLegs_unidentified_noBack_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import StarLegs_unidentified_noArms_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import StarLegs_noBack_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import StarLegs_noBack_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import StarLegs_noArms_unidentified_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import StarLegs_noArms_noBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoArms_unidentified_noBack_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoArms_unidentified_starLegs_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoArms_noBack_unidentified_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoArms_noBack_starLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoArms_starLegs_unidentified_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';
import NoArms_starLegs_noBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_noArms.png';

import Unidentified_noBack_starLegs_wArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import Unidentified_noBack_wArms_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import Unidentified_starLegs_noBack_wArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import Unidentified_starLegs_wArms_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import Unidentified_wArms_noBack_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import Unidentified_wArms_starLegs_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import NoBack_unidentified_starLegs_wArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import NoBack_unidentified_wArms_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import NoBack_starLegs_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import NoBack_starLegs_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import NoBack_wArms_unidentified_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import NoBack_wArms_starLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import StarLegs_unidentified_noBack_wArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import StarLegs_unidentified_wArms_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import StarLegs_noBack_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import StarLegs_noBack_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import StarLegs_wArms_unidentified_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import StarLegs_wArms_noBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import wArms_unidentified_noBack_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import wArms_unidentified_starLegs_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import wArms_noBack_unidentified_starLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import wArms_noBack_starLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import wArms_starLegs_unidentified_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';
import wArms_starLegs_noBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_starLegs_wArms.png';

import Unidentified_noBack_unidentifiedLegs_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import Unidentified_noBack_noArms_unidentifiedLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import Unidentified_unidentifiedLegs_noBack_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import Unidentified_unidentifiedLegs_noArms_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import Unidentified_noArms_noBack_unidentifiedLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import Unidentified_noArms_unidentifiedLegs_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoBack_unidentified_unidentifiedLegs_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoBack_unidentified_noArms_unidentifiedLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoBack_unidentifiedLegs_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoBack_unidentifiedLegs_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoBack_noArms_unidentified_unidentifiedLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoBack_noArms_unidentifiedLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_unidentified_noBack_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_unidentified_noArms_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noBack_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noBack_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noArms_unidentified_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import UnidentifiedLegs_noArms_noBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoArms_unidentified_noBack_unidentifiedLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoArms_unidentified_unidentifiedLegs_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoArms_noBack_unidentified_unidentifiedLegs from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoArms_noBack_unidentifiedLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoArms_unidentifiedLegs_unidentified_noBack from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';
import NoArms_unidentifiedLegs_noBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_noBack_unidentifiedLegs_noArms.png';

import Unidentified_wBack_fourLegs_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import Unidentified_wBack_noArms_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import Unidentified_fourLegs_wBack_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import Unidentified_fourLegs_noArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import Unidentified_noArms_wBack_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import Unidentified_noArms_fourLegs_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import WBack_unidentified_fourLegs_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import WBack_unidentified_noArms_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import WBack_fourLegs_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import WBack_fourLegs_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import WBack_noArms_unidentified_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import WBack_noArms_fourLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import FourLegs_unidentified_wBack_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import FourLegs_unidentified_noArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import FourLegs_wBack_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import FourLegs_wBack_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import FourLegs_noArms_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import FourLegs_noArms_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import NoArms_unidentified_wBack_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import NoArms_unidentified_fourLegs_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import NoArms_wBack_unidentified_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import NoArms_wBack_fourLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import NoArms_fourLegs_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';
import NoArms_fourLegs_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_noArms.png';

import Unidentified_wBack_fourLegs_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import Unidentified_wBack_wArms_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import Unidentified_fourLegs_wBack_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import Unidentified_fourLegs_wArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import Unidentified_wArms_wBack_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import Unidentified_wArms_fourLegs_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WBack_unidentified_fourLegs_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WBack_unidentified_wArms_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WBack_fourLegs_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WBack_fourLegs_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WBack_wArms_unidentified_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WBack_wArms_fourLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import FourLegs_unidentified_wBack_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import FourLegs_unidentified_wArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import FourLegs_wBack_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import FourLegs_wBack_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import FourLegs_wArms_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import FourLegs_wArms_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WArms_unidentified_wBack_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WArms_unidentified_fourLegs_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WArms_wBack_unidentified_fourLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WArms_wBack_fourLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WArms_fourLegs_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';
import WArms_fourLegs_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_fourLegs_wArms.png';

import Unidentified_wBack_otherLegType_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import Unidentified_wBack_noArms_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import Unidentified_otherLegType_wBack_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import Unidentified_otherLegType_noArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import Unidentified_noArms_wBack_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import Unidentified_noArms_otherLegType_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import WBack_unidentified_otherLegType_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import WBack_unidentified_noArms_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import WBack_otherLegType_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import WBack_otherLegType_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import WBack_noArms_unidentified_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import WBack_noArms_otherLegType_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import OtherLegType_unidentified_wBack_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import OtherLegType_unidentified_noArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import OtherLegType_wBack_unidentified_noArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import OtherLegType_wBack_noArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import OtherLegType_noArms_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import OtherLegType_noArms_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import NoArms_unidentified_wBack_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import NoArms_unidentified_otherLegType_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import NoArms_wBack_unidentified_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import NoArms_wBack_otherLegType_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import NoArms_otherLegType_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';
import NoArms_otherLegType_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_noArms.png';

import Unidentified_wBack_otherLegType_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import Unidentified_wBack_wArms_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import Unidentified_otherLegType_wBack_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import Unidentified_otherLegType_wArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import Unidentified_wArms_wBack_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import Unidentified_wArms_otherLegType_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WBack_unidentified_otherLegType_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WBack_unidentified_wArms_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WBack_otherLegType_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WBack_otherLegType_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WBack_wArms_unidentified_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WBack_wArms_otherLegType_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import OtherLegType_unidentified_wBack_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import OtherLegType_unidentified_wArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import OtherLegType_wBack_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import OtherLegType_wBack_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import OtherLegType_wArms_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import OtherLegType_wArms_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WArms_unidentified_wBack_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WArms_unidentified_otherLegType_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WArms_wBack_unidentified_otherLegType from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WArms_wBack_otherLegType_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WArms_otherLegType_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';
import WArms_otherLegType_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_otherLegType_wArms.png';

import Unidentified_wBack_starLegs_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import Unidentified_wBack_wArms_starLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import Unidentified_starLegs_wBack_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import Unidentified_starLegs_wArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import Unidentified_wArms_wBack_starLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import Unidentified_wArms_starLegs_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WBack_unidentified_starLegs_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WBack_unidentified_wArms_starLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WBack_starLegs_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WBack_starLegs_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WBack_wArms_unidentified_starLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WBack_wArms_starLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import StarLegs_unidentified_wBack_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import StarLegs_unidentified_wArms_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import StarLegs_wBack_unidentified_wArms from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import StarLegs_wBack_wArms_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import StarLegs_wArms_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import StarLegs_wArms_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WArms_unidentified_wBack_starLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WArms_unidentified_starLegs_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WArms_wBack_unidentified_starLegs from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WArms_wBack_starLegs_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WArms_starLegs_unidentified_wBack from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';
import WArms_starLegs_wBack_unidentified from '@/assets/images/scan/Chairs/Unidentified_wBack_starLegs_wArms.png';

//Sofas
import DefaultSofa from '@/assets/images/scan/Sofas/DefaultSofa.png';
import LShaped from '@/assets/images/scan/Sofas/LShaped.png';
import LShapedExtension from '@/assets/images/scan/Sofas/LShapedExtension.png';
import Rectangular from '@/assets/images/scan/Sofas/Rectangular.png';
import SingleSeat from '@/assets/images/scan/Sofas/SingleSeat.png';
import UnidentifiedSofa from '@/assets/images/scan/Sofas/UnidentifiedSofa.png';
//Beds
import DefaultBed from '@/assets/images/scan/Beds/DefaultBed.png';


export const imageMap: Record<string, StaticImageData> = {
    // Tables
    CoffeeTable_circularElliptic,
    CircularElliptic_coffeeTable,
    CoffeeTable_rectangular,
    Rectangular_coffeeTable,
    CoffeeTable_unidentifiedShape,
    UnidentifiedShape_coffeeTable,
    DefaultTable,
    DiningTable_circularElliptic,
    CircularElliptic_diningTable,
    DiningTable_rectangular,
    Rectangular_diningTable,
    DiningTable_unidentifiedShape,
    UnidentifiedShape_diningTable,
    Unidentified_circularElliptic,
    CircularElliptic_unidentified,
    Unidentified_lShaped,
    LShaped_unidentified,
    Unidentified_rectangular,
    Rectangular_unidentified,
    Unidentified_unidentifiedShape,
    UnidentifiedShape_unidentified,
  
    // Chairs
    DefaultChair,
    DiningChair_wBack_fourLegs_noArms,
    DiningChair_wBack_noArms_fourLegs,
    DiningChair_fourLegs_wBack_noArms,
    DiningChair_fourLegs_noArms_wBack,
    DiningChair_noArms_wBack_fourLegs,
    DiningChair_noArms_fourLegs_wBack,
    WBack_diningChair_fourLegs_noArms,
    WBack_diningChair_noArms_fourLegs,
    WBack_fourLegs_diningChair_noArms,
    WBack_fourLegs_noArms_diningChair,
    WBack_noArms_diningChair_fourLegs,
    WBack_noArms_fourLegs_diningChair,
    FourLegs_diningChair_wBack_noArms,
    FourLegs_diningChair_noArms_wBack,
    FourLegs_wBack_diningChair_noArms,
    FourLegs_wBack_noArms_diningChair,
    FourLegs_noArms_diningChair_wBack,
    FourLegs_noArms_wBack_diningChair,
    NoArms_diningChair_wBack_fourLegs,
    NoArms_diningChair_fourLegs_wBack,
    NoArms_wBack_diningChair_fourLegs,
    NoArms_wBack_fourLegs_diningChair,
    NoArms_fourLegs_diningChair_wBack,
    NoArms_fourLegs_wBack_diningChair,

    DiningChair_wBack_fourLegs_wArms,
    DiningChair_wBack_wArms_fourLegs,
    DiningChair_fourLegs_wBack_wArms,
    DiningChair_fourLegs_wArms_wBack,
    DiningChair_wArms_wBack_fourLegs,
    DiningChair_wArms_fourLegs_wBack,
    WBack_diningChair_fourLegs_wArms,
    WBack_diningChair_wArms_fourLegs,
    WBack_fourLegs_diningChair_wArms,
    WBack_fourLegs_wArms_diningChair,
    WBack_wArms_diningChair_fourLegs,
    WBack_wArms_fourLegs_diningChair,
    FourLegs_diningChair_wBack_wArms,
    FourLegs_diningChair_wArms_wBack,
    FourLegs_wBack_diningChair_wArms,
    FourLegs_wBack_wArms_diningChair,
    FourLegs_wArms_diningChair_wBack,
    FourLegs_wArms_wBack_diningChair,
    WArms_diningChair_wBack_fourLegs,
    WArms_diningChair_fourLegs_wBack,
    WArms_wBack_diningChair_fourLegs,
    WArms_wBack_fourLegs_diningChair,
    WArms_fourLegs_diningChair_wBack,
    WArms_fourLegs_wBack_diningChair,

    Stool_noBack_fourLegs_noArms,
    Stool_noBack_noArms_fourLegs,
    Stool_fourLegs_noBack_noArms,
    Stool_fourLegs_noArms_noBack,
    Stool_noArms_noBack_fourLegs,
    Stool_noArms_fourLegs_noBack,
    NoBack_stool_fourLegs_noArms,
    NoBack_stool_noArms_fourLegs,
    NoBack_fourLegs_stool_noArms,
    NoBack_fourLegs_noArms_stool,
    NoBack_noArms_stool_fourLegs,
    NoBack_noArms_fourLegs_stool,
    FourLegs_stool_noBack_noArms,
    FourLegs_stool_noArms_noBack,
    FourLegs_noBack_stool_noArms,
    FourLegs_noBack_noArms_stool,
    FourLegs_noArms_stool_noBack,
    FourLegs_noArms_noBack_stool,
    NoArms_stool_noBack_fourLegs,
    NoArms_stool_fourLegs_noBack,
    NoArms_noBack_stool_fourLegs,
    NoArms_noBack_fourLegs_stool,
    NoArms_fourLegs_stool_noBack,
    NoArms_fourLegs_noBack_stool,

    Stool_noBack_starLegs_noArms,
    Stool_noBack_noArms_starLegs,
    Stool_starLegs_noBack_noArms,
    Stool_starLegs_noArms_noBack,
    Stool_noArms_noBack_starLegs,
    Stool_noArms_starLegs_noBack,
    NoBack_stool_starLegs_noArms,
    NoBack_stool_noArms_starLegs,
    NoBack_starLegs_stool_noArms,
    NoBack_starLegs_noArms_stool,
    NoBack_noArms_stool_starLegs,
    NoBack_noArms_starLegs_stool,
    StarLegs_stool_noBack_noArms,
    StarLegs_stool_noArms_noBack,
    StarLegs_noBack_stool_noArms,
    StarLegs_noBack_noArms_stool,
    StarLegs_noArms_stool_noBack,
    StarLegs_noArms_noBack_stool,
    NoArms_stool_noBack_starLegs,
    NoArms_stool_starLegs_noBack,
    NoArms_noBack_stool_starLegs,
    NoArms_noBack_starLegs_stool,
    NoArms_starLegs_stool_noBack,
    NoArms_starLegs_noBack_stool,

    Stool_noBack_starLegs_wArms,
    Stool_noBack_wArms_starLegs,
    Stool_starLegs_noBack_wArms,
    Stool_starLegs_wArms_noBack,
    Stool_wArms_noBack_starLegs,
    Stool_wArms_starLegs_noBack,
    NoBack_stool_starLegs_wArms,
    NoBack_stool_wArms_starLegs,
    NoBack_starLegs_stool_wArms,
    NoBack_starLegs_wArms_stool,
    NoBack_wArms_stool_starLegs,
    NoBack_wArms_starLegs_stool,
    StarLegs_stool_noBack_wArms,
    StarLegs_stool_wArms_noBack,
    StarLegs_noBack_stool_wArms,
    StarLegs_noBack_wArms_stool,
    StarLegs_wArms_stool_noBack,
    StarLegs_wArms_noBack_stool,
    WArms_stool_noBack_starLegs,
    WArms_stool_starLegs_noBack,
    WArms_noBack_stool_starLegs,
    WArms_noBack_starLegs_stool,
    WArms_starLegs_stool_noBack,
    WArms_starLegs_noBack_stool,

    Stool_noBack_unidentifiedLegs_wArms,
    Stool_noBack_wArms_unidentifiedLegs,
    Stool_unidentifiedLegs_noBack_wArms,
    Stool_unidentifiedLegs_wArms_noBack,
    Stool_wArms_noBack_unidentifiedLegs,
    Stool_wArms_unidentifiedLegs_noBack,
    NoBack_stool_unidentifiedLegs_wArms,
    NoBack_stool_wArms_unidentifiedLegs,
    NoBack_unidentifiedLegs_stool_wArms,
    NoBack_unidentifiedLegs_wArms_stool,
    NoBack_wArms_stool_unidentifiedLegs,
    NoBack_wArms_unidentifiedLegs_stool,
    UnidentifiedLegs_stool_noBack_wArms,
    UnidentifiedLegs_stool_wArms_noBack,
    UnidentifiedLegs_noBack_stool_wArms,
    UnidentifiedLegs_noBack_wArms_stool,
    UnidentifiedLegs_wArms_stool_noBack,
    UnidentifiedLegs_wArms_noBack_stool,
    WArms_stool_noBack_unidentifiedLegs,
    WArms_stool_unidentifiedLegs_noBack,
    WArms_noBack_stool_unidentifiedLegs,
    WArms_noBack_unidentifiedLegs_stool,
    WArms_unidentifiedLegs_stool_noBack,
    WArms_unidentifiedLegs_noBack_stool,

    Stool_noBack_noArms_unidentifiedLegs,
    Stool_unidentifiedLegs_noBack_noArms,
    Stool_unidentifiedLegs_noArms_noBack,
    Stool_noArms_noBack_unidentifiedLegs,
    Stool_noArms_unidentifiedLegs_noBack,
    NoBack_stool_unidentifiedLegs_noArms,
    NoBack_stool_noArms_unidentifiedLegs,
    NoBack_unidentifiedLegs_stool_noArms,
    NoBack_unidentifiedLegs_noArms_stool,
    NoBack_noArms_stool_unidentifiedLegs,
    NoBack_noArms_unidentifiedLegs_stool,
    UnidentifiedLegs_stool_noBack_noArms,
    UnidentifiedLegs_stool_noArms_noBack,
    UnidentifiedLegs_noBack_stool_noArms,
    UnidentifiedLegs_noBack_noArms_stool,
    UnidentifiedLegs_noArms_stool_noBack,
    UnidentifiedLegs_noArms_noBack_stool,
    NoArms_stool_noBack_unidentifiedLegs,
    NoArms_stool_unidentifiedLegs_noBack,
    NoArms_noBack_stool_unidentifiedLegs,
    NoArms_noBack_unidentifiedLegs_stool,
    NoArms_unidentifiedLegs_stool_noBack,
    NoArms_unidentifiedLegs_noBack_stool,

    Swivel_wBack_starLegs_noArms,
    Swivel_wBack_noArms_starLegs,
    Swivel_starLegs_wBack_noArms,
    Swivel_starLegs_noArms_wBack,
    Swivel_noArms_wBack_starLegs,
    Swivel_noArms_starLegs_wBack,
    WBack_swivel_starLegs_noArms,
    WBack_swivel_noArms_starLegs,
    WBack_starLegs_swivel_noArms,
    WBack_starLegs_noArms_swivel,
    WBack_noArms_swivel_starLegs,
    WBack_noArms_starLegs_swivel,
    StarLegs_swivel_wBack_noArms,
    StarLegs_swivel_noArms_wBack,
    StarLegs_wBack_swivel_noArms,
    StarLegs_wBack_noArms_swivel,
    StarLegs_noArms_swivel_wBack,
    StarLegs_noArms_wBack_swivel,
    NoArms_swivel_wBack_starLegs,
    NoArms_swivel_starLegs_wBack,
    NoArms_wBack_swivel_starLegs,
    NoArms_wBack_starLegs_swivel,
    NoArms_starLegs_swivel_wBack,
    NoArms_starLegs_wBack_swivel,

    Swivel_wBack_starLegs_wArms,
    Swivel_wBack_wArms_starLegs,
    Swivel_starLegs_wBack_wArms,
    Swivel_starLegs_wArms_wBack,
    Swivel_wArms_wBack_starLegs,
    Swivel_wArms_starLegs_wBack,
    WBack_swivel_starLegs_wArms,
    WBack_swivel_wArms_starLegs,
    WBack_starLegs_swivel_wArms,
    WBack_starLegs_wArms_swivel,
    WBack_wArms_swivel_starLegs,
    WBack_wArms_starLegs_swivel,
    StarLegs_swivel_wBack_wArms,
    StarLegs_swivel_wArms_wBack,
    StarLegs_wBack_swivel_wArms,
    StarLegs_wBack_wArms_swivel,
    StarLegs_wArms_swivel_wBack,
    StarLegs_wArms_wBack_swivel,
    WArms_swivel_wBack_starLegs,
    WArms_swivel_starLegs_wBack,
    WArms_wBack_swivel_starLegs,
    WArms_wBack_starLegs_swivel,
    WArms_starLegs_swivel_wBack,
    WArms_starLegs_wBack_swivel,

    Unidentified_noBack_starLegs_noArms,
    Unidentified_noBack_noArms_starLegs,
    Unidentified_starLegs_noBack_noArms,
    Unidentified_starLegs_noArms_noBack,
    Unidentified_noArms_noBack_starLegs,
    Unidentified_noArms_starLegs_noBack,
    NoBack_unidentified_starLegs_noArms,
    NoBack_unidentified_noArms_starLegs,
    NoBack_starLegs_unidentified_noArms,
    NoBack_starLegs_noArms_unidentified,
    NoBack_noArms_unidentified_starLegs,
    NoBack_noArms_starLegs_unidentified,
    StarLegs_unidentified_noBack_noArms,
    StarLegs_unidentified_noArms_noBack,
    StarLegs_noBack_unidentified_noArms,
    StarLegs_noBack_noArms_unidentified,
    StarLegs_noArms_unidentified_noBack,
    StarLegs_noArms_noBack_unidentified,
    NoArms_unidentified_noBack_starLegs,
    NoArms_unidentified_starLegs_noBack,
    NoArms_noBack_unidentified_starLegs,
    NoArms_noBack_starLegs_unidentified,
    NoArms_starLegs_unidentified_noBack,
    NoArms_starLegs_noBack_unidentified,

    Unidentified_noBack_starLegs_wArms,
    Unidentified_noBack_wArms_starLegs,
    Unidentified_starLegs_noBack_wArms,
    Unidentified_starLegs_wArms_noBack,
    Unidentified_wArms_noBack_starLegs,
    Unidentified_wArms_starLegs_noBack,
    NoBack_unidentified_starLegs_wArms,
    NoBack_unidentified_wArms_starLegs,
    NoBack_starLegs_unidentified_wArms,
    NoBack_starLegs_wArms_unidentified,
    NoBack_wArms_unidentified_starLegs,
    NoBack_wArms_starLegs_unidentified,
    StarLegs_unidentified_noBack_wArms,
    StarLegs_unidentified_wArms_noBack,
    StarLegs_noBack_unidentified_wArms,
    StarLegs_noBack_wArms_unidentified,
    StarLegs_wArms_unidentified_noBack,
    StarLegs_wArms_noBack_unidentified,
    wArms_unidentified_noBack_starLegs,
    wArms_unidentified_starLegs_noBack,
    wArms_noBack_unidentified_starLegs,
    wArms_noBack_starLegs_unidentified,
    wArms_starLegs_unidentified_noBack,
    wArms_starLegs_noBack_unidentified,

    Unidentified_noBack_unidentifiedLegs_noArms,
    Unidentified_noBack_noArms_unidentifiedLegs,
    Unidentified_unidentifiedLegs_noBack_noArms,
    Unidentified_unidentifiedLegs_noArms_noBack,
    Unidentified_noArms_noBack_unidentifiedLegs,
    Unidentified_noArms_unidentifiedLegs_noBack,
    NoBack_unidentified_unidentifiedLegs_noArms,
    NoBack_unidentified_noArms_unidentifiedLegs,
    NoBack_unidentifiedLegs_unidentified_noArms,
    NoBack_unidentifiedLegs_noArms_unidentified,
    NoBack_noArms_unidentified_unidentifiedLegs,
    NoBack_noArms_unidentifiedLegs_unidentified,
    UnidentifiedLegs_unidentified_noBack_noArms,
    UnidentifiedLegs_unidentified_noArms_noBack,
    UnidentifiedLegs_noBack_unidentified_noArms,
    UnidentifiedLegs_noBack_noArms_unidentified,
    UnidentifiedLegs_noArms_unidentified_noBack,
    UnidentifiedLegs_noArms_noBack_unidentified,
    NoArms_unidentified_noBack_unidentifiedLegs,
    NoArms_unidentified_unidentifiedLegs_noBack,
    NoArms_noBack_unidentified_unidentifiedLegs,
    NoArms_noBack_unidentifiedLegs_unidentified,
    NoArms_unidentifiedLegs_unidentified_noBack,
    NoArms_unidentifiedLegs_noBack_unidentified,

    Unidentified_wBack_fourLegs_noArms,
    Unidentified_wBack_noArms_fourLegs,
    Unidentified_fourLegs_wBack_noArms,
    Unidentified_fourLegs_noArms_wBack,
    Unidentified_noArms_wBack_fourLegs,
    Unidentified_noArms_fourLegs_wBack,
    WBack_unidentified_fourLegs_noArms,
    WBack_unidentified_noArms_fourLegs,
    WBack_fourLegs_unidentified_noArms,
    WBack_fourLegs_noArms_unidentified,
    WBack_noArms_unidentified_fourLegs,
    WBack_noArms_fourLegs_unidentified,
    FourLegs_unidentified_wBack_noArms,
    FourLegs_unidentified_noArms_wBack,
    FourLegs_wBack_unidentified_noArms,
    FourLegs_wBack_noArms_unidentified,
    FourLegs_noArms_unidentified_wBack,
    FourLegs_noArms_wBack_unidentified,
    NoArms_unidentified_wBack_fourLegs,
    NoArms_unidentified_fourLegs_wBack,
    NoArms_wBack_unidentified_fourLegs,
    NoArms_wBack_fourLegs_unidentified,
    NoArms_fourLegs_unidentified_wBack,
    NoArms_fourLegs_wBack_unidentified,

    Unidentified_wBack_fourLegs_wArms,
    Unidentified_wBack_wArms_fourLegs,
    Unidentified_fourLegs_wBack_wArms,
    Unidentified_fourLegs_wArms_wBack,
    Unidentified_wArms_wBack_fourLegs,
    Unidentified_wArms_fourLegs_wBack,
    WBack_unidentified_fourLegs_wArms,
    WBack_unidentified_wArms_fourLegs,
    WBack_fourLegs_unidentified_wArms,
    WBack_fourLegs_wArms_unidentified,
    WBack_wArms_unidentified_fourLegs,
    WBack_wArms_fourLegs_unidentified,
    FourLegs_unidentified_wBack_wArms,
    FourLegs_unidentified_wArms_wBack,
    FourLegs_wBack_unidentified_wArms,
    FourLegs_wBack_wArms_unidentified,
    FourLegs_wArms_unidentified_wBack,
    FourLegs_wArms_wBack_unidentified,
    WArms_unidentified_wBack_fourLegs,
    WArms_unidentified_fourLegs_wBack,
    WArms_wBack_unidentified_fourLegs,
    WArms_wBack_fourLegs_unidentified,
    WArms_fourLegs_unidentified_wBack,
    WArms_fourLegs_wBack_unidentified,

    Unidentified_wBack_otherLegType_noArms,
    Unidentified_wBack_noArms_otherLegType,
    Unidentified_otherLegType_wBack_noArms,
    Unidentified_otherLegType_noArms_wBack,
    Unidentified_noArms_wBack_otherLegType,
    Unidentified_noArms_otherLegType_wBack,
    WBack_unidentified_otherLegType_noArms,
    WBack_unidentified_noArms_otherLegType,
    WBack_otherLegType_unidentified_noArms,
    WBack_otherLegType_noArms_unidentified,
    WBack_noArms_unidentified_otherLegType,
    WBack_noArms_otherLegType_unidentified,
    OtherLegType_unidentified_wBack_noArms,
    OtherLegType_unidentified_noArms_wBack,
    OtherLegType_wBack_unidentified_noArms,
    OtherLegType_wBack_noArms_unidentified,
    OtherLegType_noArms_unidentified_wBack,
    OtherLegType_noArms_wBack_unidentified,
    NoArms_unidentified_wBack_otherLegType,
    NoArms_unidentified_otherLegType_wBack,
    NoArms_wBack_unidentified_otherLegType,
    NoArms_wBack_otherLegType_unidentified,
    NoArms_otherLegType_unidentified_wBack,
    NoArms_otherLegType_wBack_unidentified,
    
    Unidentified_wBack_otherLegType_wArms,
    Unidentified_wBack_wArms_otherLegType,
    Unidentified_otherLegType_wBack_wArms,
    Unidentified_otherLegType_wArms_wBack,
    Unidentified_wArms_wBack_otherLegType,
    Unidentified_wArms_otherLegType_wBack,
    WBack_unidentified_otherLegType_wArms,
    WBack_unidentified_wArms_otherLegType,
    WBack_otherLegType_unidentified_wArms,
    WBack_otherLegType_wArms_unidentified,
    WBack_wArms_unidentified_otherLegType,
    WBack_wArms_otherLegType_unidentified,
    OtherLegType_unidentified_wBack_wArms,
    OtherLegType_unidentified_wArms_wBack,
    OtherLegType_wBack_unidentified_wArms,
    OtherLegType_wBack_wArms_unidentified,
    OtherLegType_wArms_unidentified_wBack,
    OtherLegType_wArms_wBack_unidentified,
    WArms_unidentified_wBack_otherLegType,
    WArms_unidentified_otherLegType_wBack,
    WArms_wBack_unidentified_otherLegType,
    WArms_wBack_otherLegType_unidentified,
    WArms_otherLegType_unidentified_wBack,
    WArms_otherLegType_wBack_unidentified,

    Unidentified_wBack_starLegs_wArms,
    Unidentified_wBack_wArms_starLegs,
    Unidentified_starLegs_wBack_wArms,
    Unidentified_starLegs_wArms_wBack,
    Unidentified_wArms_wBack_starLegs,
    Unidentified_wArms_starLegs_wBack,
    WBack_unidentified_starLegs_wArms,
    WBack_unidentified_wArms_starLegs,
    WBack_starLegs_unidentified_wArms,
    WBack_starLegs_wArms_unidentified,
    WBack_wArms_unidentified_starLegs,
    WBack_wArms_starLegs_unidentified,
    StarLegs_unidentified_wBack_wArms,
    StarLegs_unidentified_wArms_wBack,
    StarLegs_wBack_unidentified_wArms,
    StarLegs_wBack_wArms_unidentified,
    StarLegs_wArms_unidentified_wBack,
    StarLegs_wArms_wBack_unidentified,
    WArms_unidentified_wBack_starLegs,
    WArms_unidentified_starLegs_wBack,
    WArms_wBack_unidentified_starLegs,
    WArms_wBack_starLegs_unidentified,
    WArms_starLegs_unidentified_wBack,
    WArms_starLegs_wBack_unidentified,

    // Sofas
    DefaultSofa,
    LShaped,
    LShapedExtension,
    Rectangular,
    SingleSeat,
    UnidentifiedSofa,

    // Beds
    DefaultBed,
};